import WalletService from "./WalletService";

export async function fetchWalletTransactions({ walletId, skip, limit, sort_by, sort_order, filters, language}) {
  const currentLang = language || localStorage.getItem("i18nextLng") || "en";
  const data = await WalletService.getTransactions({
    walletId,
    skip,
    limit,
    sort_by,
    sort_order,
    filters,
    language: currentLang,
  });

  return {
    items: data.items || [],
    total: data.total || (data.items ? data.items.length : 0),
    filtered: null,
  };
}
